import { Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { Destroyable, SaveForm } from '@tokeet-frontend/tv3-platform'
import { notAllSpacesValidator } from '@tokeet-frontend/tv3-platform'
import { FetchGuests, UpdateGuest } from '@tv3/store/guest/guest.actions'
import { Guest } from '@tv3/store/guest/guest.model'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { InitialWhatsappDialogService } from '../initial-whatsapp-dialog/initial-whatsapp-dialog.service'

@Component({
  selector: 'app-connect-whatsapp-dialog',
  templateUrl: './connect-whatsapp-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./connect-whatsapp-dialog.component.scss'],
})
export class ConnectWhatsappDialogComponent extends Destroyable implements OnInit {
  form = this.fb.group({
    whatsapp_phone: ['', [notAllSpacesValidator, Validators.required]],
  })

  get guest(): Guest {
    return this.data.guest
  }

  get inquiry(): Inquiry {
    return this.data.inquiry
  }

  constructor(
    public dialogRef: MatDialogRef<ConnectWhatsappDialogComponent>,
    private fb: FormBuilder,
    private store: Store<any>,
    private initialWhatsappDialog: InitialWhatsappDialogService,
    @Inject(MAT_DIALOG_DATA) public data: { guest: Guest; inquiry?: Inquiry }
  ) {
    super()
  }

  ngOnInit() {
    this.store.dispatch(FetchGuests({ ids: [this.guest.id] }))
    this.form.patchValue({ whatsapp_phone: this.guest.whatsapp_phone || this.guest.phone })
  }

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onConnect(form: FormGroup) {
    if (this.guest.whatsapp_phone !== form.value.whatsapp_phone) {
      this.store.dispatch(UpdateGuest({ guestId: this.guest.id, form: { whatsapp_phone: form.value.whatsapp_phone } }))
    }

    this.initialWhatsappDialog
      .open({ guest: { ...this.guest, whatsapp_phone: form.value.whatsapp_phone } as any, inquiry: this.inquiry })
      .afterClosed()
      .subscribe((res) => {
        if (res === 'sent') {
          this.close()
        }
      })
  }
}
